import { IPoint } from '@/store/ui/interfaces'
import dayjs from 'dayjs'
import 'dayjs/locale/de'
import CustomParseFormat from 'dayjs/plugin/customParseFormat'
import localforage from 'localforage'
import { IColumnWidths, IDateFormat, IKeyCodes, IUrls } from './interfaces'
import { CLASSIC, CLASSICAI, COMFORTAI, IND, INDAI } from './master-data'
const { createInstance } = localforage

dayjs.extend(CustomParseFormat)
dayjs.locale('de')

export const getLocalForage = () => {
  let localForage: LocalForage | null = null

  if (typeof window !== 'undefined') {
    localForage = createInstance({
      name: 'expinet-profile',
    })
  }

  return localForage
}

const localForage = getLocalForage()

export const URLs: IUrls = {
  dev: {
    validation: 'https://sso-stage.id.aida.de/sso/validate?service=http://gecko-dev:8080&ticket=',
    login: 'https://sso-stage.id.aida.de/sso/login?service=http://gecko-dev:8080&gateway=false',
    expinet: 'http://gecko-dev:8080',
    profile: 'https://sso-stage.id.aida.de/profile?service=http://gecko-dev:8080&netid=',
    bewotec: 'https://api.aida.de/expitec-itg',
    bewotecApiKey: '679e1dc2-96e8-490b-9a84-9df85e0f1dcb',
  },
  test: {
    validation: 'https://sso-stage.id.aida.de/sso/validate?service=https://test-beta.expinet.de&ticket=',
    login: 'https://sso-stage.id.aida.de/sso/login?service=https://test-beta.expinet.de&gateway=false',
    expinet: 'https://test-beta.expinet.de/reisesuche',
    profile: 'https://sso-stage.id.aida.de/profile?service=https://test-beta.expinet.de&netid=',
    bewotec: 'https://api.aida.de/expitec-itg',
    bewotecApiKey: '679e1dc2-96e8-490b-9a84-9df85e0f1dcb',
  },
  prod: {
    validation: 'https://sso.id.aida.de/sso/validate?service=https://beta.expinet.de&ticket=',
    login: 'https://sso.id.aida.de/sso/login?service=https://beta.expinet.de&gateway=false',
    expinet: 'https://beta.expinet.de/reisesuche',
    profile: 'https://sso.id.aida.de/profile?service=https://beta.expinet.de&netid=',
    bewotec: 'https://api.aida.de/expitec',
    bewotecApiKey: 'daa660c1-bf4c-4e0d-bc63-487059bee6d1',
  },
}

export const STAGE = process.env.STAGE
export const isDevSTAGE = STAGE === 'dev'
export const isTestSTAGE = STAGE === 'test'

export const KEY_CODES: IKeyCodes = {
  BACKSPACE: 'Backspace',
  TAB: 'Tab',
  ENTER: 'Enter',
  SPACE: 'Space',
  ARROW_UP: 'ArrowUp',
  ARROW_DOWN: 'ArrowDown',
  ESCAPE: 'Escape',
  D: 'KeyD',
  R: 'KeyR',
  S: 'KeyS',
}

export const COLUMN_WIDTHS: IColumnWidths = {
  abfahrt: 90,
  route: 217,
  dauer: 34,
  schiff: 34,
  flüge: 196,
  bett: 34,
  comfort_all_inclusive: 149,
  premium_all_inclusive: 149,
  premium: 149,
  classic_all_inclusive: 149,
  classic: 149,
  specials: 149,
  button: 75,
}

export const VALID_DATE_FORMATS: IDateFormat[] = [
  { format: 'DD.MM.YYYY', autoComplete: false },
  { format: 'DD.MM.YY', autoComplete: false },
  { format: 'DD.MM.', autoComplete: true },
  { format: 'DD,MM,YYYY', autoComplete: false },
  { format: 'DD,MM,YY', autoComplete: false },
  { format: 'DD,MM,', autoComplete: true },
  { format: 'DDMMYYYY', autoComplete: false },
  { format: 'DDMMYY', autoComplete: false },
  { format: 'DDMM', autoComplete: true },
]

export const ISO_DATE_FORMAT = 'YYYY-MM-DD'
export const DEFAULT_DATE_FORMAT = 'DD.MM.YYYY'
export const DEFAULT_DATE_TIME_FORMAT = 'DD.MM.YYYY HH:mm'
export const EXTENDED_DATE_FORMAT = 'DD.MM.YYYY HH:mm:ss'
export const DEFAULT_TIME_FORMAT = 'HH:mm'
export const DEFAULT_DATE_FORMAT_WITH_WEEKDAY = 'dd, DD.MM.YY'

export const getValidDateFormat = (dateTime: string) => {
  return !!dateTime.match(':') ? EXTENDED_DATE_FORMAT : DEFAULT_DATE_FORMAT
}

export const convertFormat = (str: string, srcFmt: string, destFmt: string) => {
  const convertedFormat = dayjs(str, srcFmt).format(destFmt)
  return convertedFormat === '00:00' ? '' : convertedFormat
}

export const restoreURL = async () => {
  let queryStrings = ''

  await localForage?.getItem('filterPreset', (_err, value: string | null) => (queryStrings = value || ''))
  const path = URLs[STAGE as keyof IUrls].expinet + queryStrings
  changeDisplayedURL(path)
}

export const deleteQueryStrings = () => {
  const path = URLs[STAGE as keyof IUrls].expinet
  globalHelper.changeDisplayedURL(path)
}

export const changeDisplayedURL = (path: string) => {
  if (typeof window !== 'undefined') {
    history.replaceState({ path }, '', path)
  }
}

export const SORT_KEYS = {
  comfortai: COMFORTAI,
  premiumai: INDAI,
  premium: IND,
  classicai: CLASSICAI,
  classic: CLASSIC,
  abfahrt: 'abfahrt',
  route: 'route',
}

export const generateRequestId = (identifier: string): string => {
  return identifier + Math.random().toString(16).slice(2)
}

export const toolTipPosition = (refName: string, orient?: string): IPoint => {
  const ref = document.getElementById(refName)

  if (!ref) return { x: 0, y: 0 }

  orient = orient || 'bottom'
  
  const rect = ref.getClientRects()[0]
  
  return {
    x: rect.left,
    y: orient === 'bottom' ? rect.top + rect.height : rect.top,
  }
}

export const isForcedError = () => {
  const hasFeatureFlag = window.location.href.toLowerCase().includes('isforcederror')
  const isStage = process.env.STAGE !== 'prod'

  return hasFeatureFlag && isStage
}

export const globalHelper = {
  deleteQueryStrings,
  changeDisplayedURL,
  generateRequestId,
  isForcedError,
}
